import React from 'react';
import {Avatar, Tag} from 'antd';
import dayjs from 'dayjs';
import {EnvironmentOutlined} from '@/icons';
import styles from '@/page/customer/index.module.less';

const columnDefines = () => ({
    avatar: {
        title: '姓名',
        dataIndex: 'sysUser',
        render: sysUser => (
            <>
                <Avatar src={sysUser.avatar} /> {sysUser.name}({sysUser.extId})
            </>
        ),
    },
    visibleType: {
        title: '可见范围',
        width: 100,
        dataIndex: 'visibleType',
        render: visibleType =>
            visibleType === 0 ? (
                <span style={{color: '#FF4A4B'}}>部分可见</span>
            ) : (
                <span style={{color: '#04C160'}}>公开</span>
            ),
    },
    latitudeName: {
        title: '地址位置',
        dataIndex: 'latitudeName',
        render: latitudeName =>
            latitudeName ? (
                <Tag
                    style={{color: '#333333', border: '1px soild #333333'}}
                    icon={<EnvironmentOutlined />}
                >
                    {latitudeName}
                </Tag>
            ) : (
                <Tag style={{color: '#999999'}}>暂无地址</Tag>
            ),
    },
    content: {
        title: '朋友圈内容',
        dataIndex: 'content',
        render: content => (
            <>
                {content ? (
                    <div className={styles.word}>
                        <Tag
                            style={{
                                maxWidth: '400px',
                                background: '#F7F9FC',
                                border: '1px solid rgba(204, 211, 237,.1)',
                            }}
                        >
                            <a title={content} style={{color: '#152D85'}}>
                                {content.length > 20 ? content.substr(0, 20) + '...' : content}
                            </a>
                        </Tag>
                    </div>
                ) : (
                    <Tag style={{color: '#999999'}}>无文字内容</Tag>
                )}
            </>
        ),
    },
    momentCreateTime: {
        title: '发布时间',
        dataIndex: 'momentCreateTime',
        render: momentCreateTime => dayjs(parseInt(momentCreateTime)).format('YYYY-MM-DD HH:mm:ss'),
    },
});

export function getColumns(keys) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
